import CryptoJS from "crypto-js";
import axios from "axios";
import { getDefaultHeaders } from "../utils/api";

export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";
export const SET_REGION = "SET_REGION";
export const SET_USER = "SET_USER";
export const SET_CART = "SET_CART";
export const SET_CART_DATA = "SET_CART_DATA";
export const LOGOUT = "LOGOUT";
export const RESET_STORE = "RESET_STORE";
export const SET_SEO_DATA = "SET_SEO_DATA";

const secretKey = "DgCMNKKey@555555";

export const logout = () => ({
  type: "LOGOUT",
});

export const resetStore = () => ({
  type: RESET_STORE,
});

export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
});

export const setRegion = (region) => ({
  type: SET_REGION,
  payload: region,
});

export const setCart = (cart) => ({
  type: SET_CART,
  payload: cart,
});

export const setCartData = (cart_data) => ({
  type: SET_CART_DATA,
  payload: cart_data,
});

export const setSeoData = (seo) => ({
  type: SET_SEO_DATA,
  payload: seo,
});

export const fetchData = (key, URL) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST, key });

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_URL}/api/${URL}`,
        {
          headers: getDefaultHeaders(),
        }
      );

      const data = response.data?.page?.data; // Axios automatically parses JSON
      dispatch({ type: FETCH_DATA_SUCCESS, key, payload: data });

      if (response.data?.page?.seo?.en) {
        dispatch(setSeoData(response.data?.page?.seo?.en));
      }
    } catch (error) {
      dispatch({
        type: FETCH_DATA_FAILURE,
        key,
        payload: error.message || "Failed to fetch data",
      });
    }
  };
};

export const fetchEmailData = async (email_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/checkemail`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({ email: email_id }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createUser = async (form_values) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/register`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(form_values),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/forgot-password`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({ email: email }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const logIn = async (email, password) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/login`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const loadCompanyLogin = async (company_user_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/loadcompanydetail`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          company_user_id: company_user_id,
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const acceptInvite = async (form_values) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/accept-invite/${form_values.token}`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(form_values),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const fetchUserData = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/me`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return error;
  }
};

// load header menus
export const headerData = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/get_all_menus`
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const loadProductList = async (
  product_category,
  region,
  pageNumber = 1,
  sorting = "price_asc",
  productid,
  toggle
) => {
  try {
    let url = `${process.env.REACT_APP_CMS_URL}/api/pages?path=/products/${product_category}&region=${region}&page=${pageNumber}&sort_by=${sorting}`;

    if (productid) {
      url += productid;
    }
    if (toggle) {
      url += `&${toggle}`;
    }

    const response = await axios.get(url, {
      headers: getDefaultHeaders(),
    });

    return response.data; // Axios automatically parses JSON
  } catch (error) {
    console.error("Error loading product list:", error);
    return null; // Graceful error handling
  }
};

export const footer_data = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/content`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const loadProductDetails = async (product_url = "") => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_CMS_URL}/api/pages`,
      {
        params: { path: `/${product_url}` }, // Correct way to pass query params in Axios
        headers: getDefaultHeaders(),
      }
    );

    return response.data; // Axios automatically parses JSON
  } catch (error) {
    console.error("Error fetching product details:", error);
    return null; // Handle errors gracefully
  }
};

export const addToCarts = async (
  productVariation,
  quantity,
  location,
  region,
  dispatch
) => {
  try {
    let cartIds = JSON.parse(localStorage.getItem("cartIds")) || [];
    let cartDatas = JSON.parse(localStorage.getItem("cartDatas")) || [];

    // Ensure cartIds is always an array
    if (!Array.isArray(cartIds)) cartIds = [];

    // Find existing cart for this location
    let existingCart = cartIds.find((cart) => cart.locationId === location);
    let cartId = existingCart ? existingCart.cartId : null;
    let cartData;

    if (cartId) {
      cartData = await addProductsToCart(cartId, productVariation, quantity);
    } else {
      // Create a new cart
      const response = await fetch(
        `${process.env.REACT_APP_CMS_URL}/api/shoppingcart/create`,
        {
          method: "POST",
          headers: getDefaultHeaders(),
          body: JSON.stringify({ region, location_id: location }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to create cart");
      }

      const result = await response.json();
      cartId = result?.id;

      // ✅ **Ensure `cartId` & `locationId` are valid before pushing**
      if (cartId && location) {
        cartIds = [...cartIds, { locationId: location, cartId }];
        localStorage.setItem("cartIds", JSON.stringify(cartIds));
      }
      cartData = await addProductsToCart(cartId, productVariation, quantity);
    }
    if (!cartData?.message) {
      // ✅ **Ensure cart data is updated correctly**
      cartDatas = cartDatas.filter((cart) => cart.cartId !== cartId);
      cartDatas.push({ cartId, cartData });

      const totalLines = cartDatas.reduce((count, cart) => {
        if (cart.cartData?.lines?.length) {
          return count + cart.cartData.lines.length;
        }
        return count;
      }, 0);

      localStorage.setItem("cartDatas", JSON.stringify(cartDatas));
      //localStorage.setItem("cartCount", totalLines);

      // ✅ **Update Redux state correctly**
      dispatch({ type: "SET_CART", payload: cartIds });
      dispatch({ type: "SET_CART_DATA", payload: cartDatas });
      dispatch({ type: "cart/setCount", payload: totalLines });

      return cartData;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
    return { success: false, message: error.message };
  }
};

export const addProductsToCart = async (cartId, productVariation, quantity) => {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.lib.WordArray.random(16);
  const data = productVariation.id.toString();
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const productVariationId = iv
    .concat(encrypted.ciphertext)
    .toString(CryptoJS.enc.Base64);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/shoppingcart/${cartId}`,
      {
        method: "PUT",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          products: [
            {
              quantity,
              product_variation_id: productVariationId,
            },
          ],
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return { success: false, message: error };
  }
};

export const logoutUsers = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/logout`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const loadCartListDetails = async (shoppingCartIds = [], dispatch) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/shoppingcart/${shoppingCartIds.join(
        ","
      )}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();

    const totalLines = result.reduce((count, cart) => {
      if (cart.lines?.length) {
        return count + cart.lines.length;
      }
      return count;
    }, 0);

    dispatch({ type: "cart/setCount", payload: totalLines });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const userProfile = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/profile`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const deletProductsToCart = async (
  cartId,
  productVariation,
  quantity
) => {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.lib.WordArray.random(16);
  const data = productVariation.id.toString();
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const productVariationId = iv
    .concat(encrypted.ciphertext)
    .toString(CryptoJS.enc.Base64);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/shoppingcart/${cartId}`,
      {
        method: "PUT",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          products: [
            {
              quantity,
              product_variation_id: productVariationId,
            },
          ],
          replace_qty: true,
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return { success: false, message: error };
  }
};

export const userNotification = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/notification-settings`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const updateProfile = async (form_values) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/update-profile`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(form_values),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const changePassword = async (form_values) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/user/change-password`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(form_values),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const calculateTotals = async (selectedLines, region) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/shoppingcart/calculate-totals?region=${region}`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          selected_carts: selectedLines,
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return { success: false, message: error };
  }
};

export const calculatePromoCodes = async (
  selectedLines,
  region,
  company_id,
  promo_code
) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/promocode/apply-promocode?region=${region}`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          selected_carts: selectedLines,
          company_id: company_id,
          promo_code: promo_code,
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return { success: false, message: error };
  }
};

export const companyProfile = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/company-profile/general`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const selfserviceOrders = async (type = "active", page = 1) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/orders?type=${type}&page=${page}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    throw error; // so useEffect can catch it
  }
};

export const selfserviceOrderdetails = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/orders/${id}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const selfserviceCredit_card = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/apply-for-credit`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const selfserviceDashboard = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/dashboard`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const selfserviceAgreedproducts = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/agreed-products`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const selfserviceUser = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/users`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const updateCompanySettings = async (form_values) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/company/settings`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(form_values),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const companyDeliveryAddresses = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/company-profile/delivery-addresses`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    console.log("action", result);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const deleteCompany = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/company/location/delete`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(formData),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const companyLocationCreation = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/company/location`,
      {
        method: "PUT",
        headers: getDefaultHeaders(),
        body: JSON.stringify(formData),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const createOrder = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/orders/create-order`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(formData),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getCompanyAddressData = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/company-profile/delivery-addresses/edit/${id}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const companyLocationUpdation = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/company/location`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(formData),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const selfserviceUseraction = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/users/edit/${id}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const orderSuccessData = async (reference) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/orders/payment-info/${reference}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const orderSuccessDataGuestUser = async (reference) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/orders/guest-user-payment-info/${reference}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const selfserviceUseractionadd = async (url, formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/company/users/${url}`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(formData),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const loadProductData = async (slug, region) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_CMS_URL}/api/products/${slug}?region=${region}`
    );
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const rfqAction = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/request-quote`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(formData),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const creatGuesteOrder = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/orders/create-order-guest-user`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify(formData),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const fetchAllProductsData = async (search_keyword) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/get-product-names?search_keyword=${search_keyword}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const loadSearchProductList = async (
  search_keyword,
  company_id,
  company_user_id,
  region,
  pageNumber = 1,
  sorting = "price_asc"
) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/search/${search_keyword}&company_id=${company_id}&company_user_id=${company_user_id}&region=${region}&page=${pageNumber}&sort_by=${sorting}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const becomeASeller = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/become-a-customer`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const userNotificationList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/self-service/user-notification`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const MarkAsReads = async (notification_id, region, company_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/general_notification/mark_as_read?region=${region}`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          company_id: company_id,
          general_notification_id: notification_id,
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const NotificationCount = async (company_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/general_notification/notify_count`,
      {
        method: "POST",
        headers: getDefaultHeaders(),
        body: JSON.stringify({
          company_id: company_id,
        }),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const productDetailsSpecs = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/product-details`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const loadCategoryDetails = async (category_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/categories/${category_id}`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

//tips and tricks
export const tipsandtricks = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CMS_URL}/api/pages?path=/tips-and-tricks`,
      {
        method: "GET",
        headers: getDefaultHeaders(),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};
